import axios from "axios";

const authReducer = (state, action) => {
    if (state === undefined) {
        state = {
            is_logged: false,
            is_waiting: false,
            user: null,
            token: localStorage.getItem("token"),
            errors: {},
            password_changed: null,
            forgot_password: null,
            register_success: null,
            change_password: null
        };
        if (state.token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${state.token}`;
        }
        return state;
    }
    switch (action.type) {
        case "LOGIN":
            localStorage.setItem("token", action.data.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${action.data.token}`;
            return {
                ...state,
                token: action.data.token,
                user: action.data.user,
                is_logged: true,
                is_waiting: false,
            };
        case "LOGIN_ERROR":
            return {
                ...state,
                errors: action.errors,
                is_waiting: false,
            };
        case "SET_AI_AVAILABILITY":
            return {
                ...state,
                user: {
                    ...state.user,
                    ai_available: action.availability
                }
            };
        case "SET_VOICE_AVAILABILITY":
            return {
                ...state,
                user: {
                    ...state.user,
                    voice_available: action.availability
                }
            };
        case "CLEAR_LOGIN_ERROR":
            return {
                ...state,
                errors: {},
                is_waiting: false,
            };
        case "REGISTER":
            return {
                ...state,
                is_waiting: false,
            }
        case "REGISTER_ERROR":
            return {
                ...state,
                errors: action.errors,
                is_waiting: false,
            };
        case "REGISTER_SUCCESS":
            return {
                ...state,
                register_success: action.success,
                is_waiting: false,
            };
        case "CLEAR_REGISTER_SUCCESS":
            return {
                ...state,
                register_success: null,
                is_waiting: false,
            };
        case "CLEAR_REGISTER_ERROR":
            return {
                ...state,
                errors: {},
                is_waiting: false,
            };
        case "LOGOUT":
            localStorage.removeItem("token");
            delete axios.defaults.headers.common['Authorization'];
            return {
                is_logged: false,
                is_waiting: false,
                user: null,
                token: null,
                errors: {}
            };
        case "SET_USER_INFO":
            return {
                ...state,
                user: action.user_info,
                is_logged: true,
                is_waiting: false,
            };
        case "SET_WAITING":
            return {
                ...state,
                is_waiting: true,
                errors: {}
            };
        case "SET_PASSWORD_CHANGE_STATUS":
            return {
                ...state,
                is_waiting: false,
                password_changed: {
                    status: action.status,
                    message: action.message,
                    errors: action.errors,
                },
            };
        case "CLEAR_PASSWORD_CHANGE_STATUS":
            return {
                ...state,
                password_changed: null,
            };
        case "SET_FORGOT_PASSWORD_STATUS":
            return {
                ...state,
                is_waiting: false,
                forgot_password: {
                    status: action.status,
                    message: action.message,
                    errors: action.errors,
                },
            };
        case "CLEAR_FORGOT_PASSWORD_STATUS":
            return {
                ...state,
                forgot_password: null,
            };
        case "CLEAR_CHANGE_PASSWORD_STATUS":
            return {
                ...state,
                change_password: null,
            };
        case "SET_CHANGE_PASSWORD_STATUS":
            return {
                ...state,
                is_waiting: false,
                change_password: {
                    status: action.status,
                    message: action.message,
                    errors: action.errors,
                },
            };
        case "CLEAR_AUTH_MESSAGES":
            return {
                ...state,
                errors: {},
                password_changed: null,
                forgot_password: null,
                register_success: null,
                change_password: null
            };
        default:
            return state
    }
};
export default authReducer;
